import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import StatBoxSlim from "components/Stats/StatBoxSlim";

const useStyles = makeStyles((theme) => ({
  titlePaper: {
    paddingTop: 8,
    paddingRight: 8,
    marginBottom: 8,
    marginLeft: 8,
    fontSize: 18,
  },
  statsBox: {
    padding: 8,
  },
  bottomBoxArea: {
    fontSize: 14,
    marginTop: 16,
  },
}));

const TreasureChestStats = ({ loading, goldChestOverview, chestType }) => {
  const classes = useStyles();

  // goldChestOverview が存在しない場合は空配列
  if (!goldChestOverview) return null;

  // total を先頭、それ以外の AMOUNT を数値降順で並べる
  const amounts = Object.keys(goldChestOverview)
    .filter((key) => key !== "total")
    .sort((a, b) => Number(b) - Number(a));

  return (
    <Grid
      container
      direction="column"
      style={{ marginTop: -8, marginBottom: 8, width: "100%" }}
    >
      <Paper style={{ padding: 8, marginBottom: 8, width: "98.6%" }}>
        <Grid
          container
          spacing={0}
          direction="row"
          style={{ marginTop: -16, marginBottom: 8, width: "100%" }}
        >
          {/* 総数 & 総額 */}
          {chestType === "gold" &&
            <Grid item xs={12} sm={6} md={6} lg={2} className={classes.statsBox}>
              <StatBoxSlim
                title="排出総額 & 排出総数"
                value={
                  loading
                    ? "loading"
                    : goldChestOverview.total
                    ? goldChestOverview.total.amount
                    : "--"
                }
                valueExtra={
                  loading
                    ? "loading"
                    : goldChestOverview.total
                    ? `${goldChestOverview.total.count} 件`
                    : "--"
                }
              />
            </Grid>
          }

          {/* 動的に AMOUNT カードを描画 */}
          {amounts.map((amount) => (
            <Grid
              key={amount}
              item
              xs={12}
              sm={6}
              md={6}
              lg={2}
              className={classes.statsBox}
            >
              <StatBoxSlim
                title={`${chestType === "gold" ? amount + "コイン排出額 & " : amount} 排出件数`}
                value={
                  loading
                    ? "loading"
                    : goldChestOverview[amount]
                    ? chestType === "gold" ? goldChestOverview[amount].amount : goldChestOverview[amount].count
                    : "--"
                }
                valueExtra={
                  loading
                    ? "loading"
                    : goldChestOverview[amount]
                    ? chestType === "gold" ? `${goldChestOverview[amount].count} 件` : ``
                    : "--"
                }
              />
            </Grid>
          ))}
        </Grid>
      </Paper>
    </Grid>
  );
};

TreasureChestStats.propTypes = {
  classes: PropTypes.object,
};

const mapStateToProps = (state) => ({
  goldChestOverview: state.pictree.goldChestOverview,
  chestType: state.pictree.chestType,
});

export default connect(mapStateToProps)(
  withStyles(null, { withTheme: true })(TreasureChestStats)
);
